module.exports = __webpack_public_path__ + "static/media/photo.75cfd8a1.png";